import React from "react";
import Button from "../ButtonUI";
import moment from "../../helper/moment";

import { ReactComponent as ThreeDots } from "../../assets/icons/icon-troisPoints.svg";
import { ReactComponent as IconMessage } from "../../assets/icons/icon-message.svg";
import { ReactComponent as Close } from "../../assets/icons/icon-close.svg";
import { ReactComponent as WomanPatient } from "../../assets/illustrations/na.svg";
import { ReactComponent as ManPatient } from "../../assets/illustrations/na.svg";
import { ReactComponent as IconCloseModal } from "../../assets/icons/icon-close.svg";
import { ReactComponent as SpecIcon } from "../../assets/icons/icon-union.svg";

import birthday from "../../assets/images/birthday.png";
import phone from "../../assets/images/phone.png";
import mail from "../../assets/images/mail.png";
import home from "../../assets/images/home.png";
import time from "../../assets/images/time.png";
import statusProgress from "../../assets/images/work-process.png";
import statusWaiting from "../../assets/images/exclamation-mark.png";
import statusDone from "../../assets/images/checked.png";
import { statusLabel } from "../../helper/demandeStatus";
import PdfDocument from "../Pdf/PdfDocument";
import TestDocument from "../Pdf/TestDocument";
//import { loadImage } from "../../api/documents";

const HeaderChat = ({ chatWithData, closeChatModal }) => {
  const [demandData, setDemandData] = React.useState() as any;
  React.useEffect(() => {
    setDemandData({
      // phone: chatWithData?.phoneNumber,
      // email: chatWithData?.email,
      // address: chatWithData?.address,
      // role: "DOCTOR",
      type: chatWithData?.type,
      specialite: chatWithData?.specialite,
      files: chatWithData?.files,
      patientId: chatWithData?.patientId,
      createdAt: chatWithData?.createdAt,
    });
  }, [chatWithData]);
  const colorAvatar = [
    "#ccd2ff",
    "#d5f0f7",
    "#ffecba",
    "#fff7ab",
    "#ffccd2",
    "#ffe2c8",
  ];
  const imgStatuts = () => {
    let imgSrc = "";
    if (
      demandData?.status === "IN_PROGRESS" ||
      demandData?.status === "SEEN_BY_EXPERT"
    ) {
      imgSrc = statusProgress;
    } else if (
      demandData?.status === "RESPONSE" ||
      demandData?.status === "SEEN_BY_REQURANT"
    ) {
      imgSrc = statusDone;
    } else {
      imgSrc = statusWaiting;
    }
    return imgSrc;
  };
  return (
    <div className="sub-container overflow-hidden">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4 relative">
        <button
          onClick={closeChatModal}
          className="absolute top-4 right-4 flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 transition"
        >
          <Close />
        </button>

        <div className="flex flex-col sm:flex-row gap-4">
          <div
            className="flex-shrink-0 w-16 h-16 rounded-full flexCenter shadow-inner"
            style={{ backgroundColor: "rgb(213, 240, 247)" }}
          >
            {demandData?.type === "Dermatose non tumorale" ? (
              <ManPatient />
            ) : (
              <WomanPatient />
            )}
          </div>

          <div className="flex-1 min-w-0">
            <h2 className="text-xl font-bold text-gray-800 capitalize">
              {demandData?.type}
            </h2>

            <p className="mt-2 text-sm text-gray-500">
              Patient : {demandData?.patientId?.firstName}{" "}
              {demandData?.patientId?.lastName}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mt-4">
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <img src={time} alt="date" className="w-4 h-4" />
                <span>{moment(demandData?.createdAt).format("L")}</span>
              </div>

              <div className="flex items-center gap-2 text-sm text-gray-600">
                <SpecIcon className="w-4 h-4" />
                <span className="capitalize">
                  {demandData?.specialite}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderChat;
